import { FC } from 'react';
import { ImproperLink } from './ImproperLink';

export const NotFound: FC = () => {
	return <ImproperLink testId="not-found" title="We can't seem to find the page you're looking for" />;
};
